import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ExhibitorsLayer from "../components/ExhibitorsLayer";

const ExhibitorsPage = () => {
  return (
    <>
      <MasterLayout>
        <ExhibitorsLayer />
      </MasterLayout>
    </>
  );
};

export default ExhibitorsPage;
